<template>
  <a-layout>
    <br />
    <a-space>
      <a-date-picker
        class="query"
        v-model="query.issueDateRange.start"
        :disabled-date="disabledStartDate"
        show-today
        valueFormat="YYYY-MM-DD"
        @change="search()"
        :placeholder="$t('business.label.issueStartTime')"
      />
      <a-date-picker
        class="query"
        v-model="query.issueDateRange.end"
        :disabled-date="disabledEndDate"
        show-today
        valueFormat="YYYY-MM-DD"
        @change="search()"
        :placeholder="$t('business.label.issueFinishTime')"
      />
      <a-input-search class="query"
                      v-model="query['wave']"
                      :placeholder="$t('business.label.wave')"
                      @pressEnter="search()"
                      @search="search()" />
      <a-input-search class="query"
                      v-model="query['order.no']"
                      :placeholder="$t('business.label.orderNo')"
                      @pressEnter="search()"
                      @search="search()" />
      <a-input-search class="query"
                      v-model="query['customer.no']"
                      :placeholder="$t('business.label.customerNo')"
                      @pressEnter="search()"
                      @search="search()" />
      <a-input-search class="query"
                      v-model="query['customer.name']"
                      :placeholder="$t('business.label.customerName')"
                      @pressEnter="search()"
                      @search="search()" />
    </a-space>
    <br />
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      @cell-click="({row})=>rowClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="issue.issueTime" title="business.label.issueTime" />
      <vxe-column title="business.label.orderNo" field="order.no" />
      <vxe-column field="dispatch.wave" title="business.label.wave" />
      <vxe-column title="business.label.customerNo" field="customer.no" />
      <vxe-column title="business.label.customerName" field="customer.name" />
      <vxe-column title="business.label.storer" field="storer.name" />
      <vxe-column title="business.label.stagingArea" field="order.stagingArea" />
      <vxe-column title="business.label.pickupMode" field="pickupMode.name" />
      <vxe-column title="business.label.orderType" field="orderType.name" />
      <vxe-column title="business.label.printTimes" field="order.printTimes" />
    </vxe-table>
    <vxe-pager
      :current-page="page"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :loading="loading"
      :page-size="size"
      :total="contentSize"
      @page-change="pageChange">
    </vxe-pager>
  </a-layout>
</template>
<script>
import moment from 'moment'
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { DeviceHandler } from '@/deviceHelper'

export default {
  name: 'DeliverPrintOrder',
  data() {
    return {
      data: [],
      contentSize: 0,
      page: 1,
      size: 5,
      loading: false,
      query: {
        issueDateRange: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'wave': '',
        'order.no': '',
        'customer.no': '',
        'customer.name': '',
        orderStatusRange: { start: 'WORK_READY', end: 'TERMINATED' },
        printConfirm: false,
        virtual: false
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.25)
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.issueDateRange.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.issueDateRange.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    search() {
      this.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      this.$emit('reset')
      let args = Object.assign({}, this.query)
      if (args.issueDateRange.start === null && args.issueDateRange.end === null) {
        args.issueDateRange = null
      }
      findAll('dispatchOrderListFactory', args, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
            this.rowClick(this.data[0])
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    rowClick(row) {
      this.$emit('rowClick', row.order.id)
    },
    reset() {
      this.query['issueDateRange'] = {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
      this.query['wave'] = ''
      this.query['order.no'] = ''
      this.query['customer.no'] = ''
      this.query['customer.name'] = ''
      this.getData()
    },
    preview() {
      let selectedRows = this.$refs.table.getCurrentRecord()
      if (selectedRows === null) {
        return this.$warning({ title: '请选择需要打印的单据', centered: true })
      }
      this.loading = true
      const args = {
        'query.no': 'saleOrderTagPrint',
        'sql': null,
        args: { so: selectedRows.order.id }
      };
      post(Api.adminQuery, {}, args).then(res => {
        if (res.success) {
          let printList=[]
          res.result.forEach((item) => {
            item.bz=item.bz?item.bz:''
          })
          printList.push(
            {
              'PLAN_CODE': '24648806',
              'WH_ID': "560456239167959042",
              'DATA': res.result,
              PREVIEW: true
            }
          )
          DeviceHandler.printWithDataList(printList, (item, res) => {
            if (res.hasOwnProperty("msg")) {
            }
          })
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    printOrder() {
      let selectedRows = this.$refs.table.getCurrentRecord()
      if (selectedRows === null) {
        return this.$warning({ title: '请选择需要打印的单据', centered: true })
      }
      this.loading = true
      const args = {
        'query.no': 'saleOrderTagPrint',
        'sql': null,
        args: { so: selectedRows.order.id }
      };
      post(Api.adminQuery, {}, args).then(res => {
        if (res.success) {
          let printList=[]
          res.result.forEach((item) => {
            item.bz=item.bz?item.bz:''
          })
          printList.push(
            {
              'PLAN_CODE': '24648806',
              'WH_ID': "560456239167959042",
              'DATA': res.result,
            }
          )
          DeviceHandler.printWithDataList(printList, (item, res) => {
            if (res.hasOwnProperty("msg")) {
            }
          })
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    printDiff() {

    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>
